import { ClientCreation } from '@Arti-zen/package-backoffice'
import { Check } from '@mui/icons-material'
import SelectMui from 'components/forms/SelectMui'
import Info from 'components/Info'
import { Row, InfoRedStyle, ValidButton, Error } from 'modules/product/ProductListTable.definitionFields'
import { useState } from 'react'

type TProps = {
  postalCode?: string
  currentCity?: string
  expectedCity: string[]
  correctClient: (corrections: Partial<ClientCreation>) => void
}

export default function CityErrorTable({ expectedCity, correctClient, postalCode, currentCity }: TProps) {
  const [city, setCity] = useState<string>(expectedCity?.[0] ?? null)
  const items = expectedCity.map((item) => {
    return { value: item, label: item }
  })

  const updateCity = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    correctClient({ city })
  }
  return (
    <div style={{ paddingTop: 4, overflowX: 'auto' }}>
      <Row style={{ gap: 15 }}>
        <div style={{ position: 'relative' }}>
          <SelectMui items={items} value={city} onChange={(item) => setCity(item)} fontSize={12} size="small" />
          <Info
            text={
              currentCity
                ? `La ville renseignée "${currentCity}" ne correspond pas au code postal "${postalCode}". Suggestions : ${expectedCity.join(', ')}.`
                : `La ville n'est pas renseignée. Suggestions par rapport au code postal : ${expectedCity.join(', ')}.`
            }
            style={{ ...InfoRedStyle, top: -4, right: -10 }}
            absolute
          />
        </div>
        <ValidButton onClick={updateCity} style={{ height: 30, fontSize: 15 }}>
          <Check fontSize="inherit" />
        </ValidButton>
      </Row>
      {currentCity && <Error style={{ margin: 0, fontSize: 12 }}>{currentCity}</Error>}
    </div>
  )
}
